import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

import { fetchData } from '../../../helpers/methods';

import SpinnerContainer from '../../../component-library/spinner-container';

import SpecificationDetails from './sub-components/specification-details';
import SpecificationUnavailable from './sub-components/specification-unavailable';

const BundleDetails = () => {
	const { data, uiMenuConfig } = useOutletContext();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [liveSpecData, setLiveSpecData] = useState([]);
	const [unavailableSpecData, setUnavailableSpecData] = useState([]);

	const getBundleData = () => {
		const urlArray = [];
		const unavailableSpecArray = [];
		const bundledSpecifications = data.bundledSpecs;
		if (bundledSpecifications.length > 0) {
			bundledSpecifications.forEach(entry => {
				if (entry.live) {
					urlArray.push(`/api/web/catalog/item/${entry.specId}/summary`);
				} else {
					unavailableSpecArray.push(entry);
				}
			});
			setUnavailableSpecData(unavailableSpecArray);
			if (urlArray.length > 0) {
				Promise.all(urlArray.map(url => fetchData({
					uri: url,
					method: 'GET',
				}).then(({ ok, body }) => {
					if (ok) {
						return body;
					}
					return 'FAIL';
				})))
					.then(newBundleData => {
						if (!newBundleData.includes('FAIL')) {
							setLiveSpecData(newBundleData);
							setLoading(false);
						} else {
							setLoading(false);
							setError(true);
						}
					})
					.catch(() => {
						setLoading(false);
						setError(true);
					});
			} else {
				setLiveSpecData([]);
				setLoading(false);
			}
		} else {
			setLiveSpecData([]);
			setUnavailableSpecData([]);
			setLoading(false);
		}
	};

	useEffect(() => {
		getBundleData();
	}, []);

	return (
		<>
			<h3>{uiMenuConfig?.bundleDetails?.label || 'Bundle Details'}</h3>
			{loading && (
				<SpinnerContainer />
			)}
			{!loading && !error && (
				<div>
					{liveSpecData?.length > 0 && (
						liveSpecData.map((specification, index) => (
							<SpecificationDetails
								// eslint-disable-next-line react/no-array-index-key
								key={index}
								specification={specification}
								methods={data.operationSpecifications}
							/>
						))
					)}
					{unavailableSpecData?.length > 0 && (
						unavailableSpecData.map((specification, index) => (
							<SpecificationUnavailable
								// eslint-disable-next-line react/no-array-index-key
								key={index}
								name={specification.designName}
							/>
						))
					)}
					{(liveSpecData?.length === 0 && unavailableSpecData?.length === 0) && (
						<p className="grey-text">No details found</p>
					)}
				</div>
			)}
			{error && (
				<p className="grey-text">No details found</p>
			)}
		</>
	);
};

export default BundleDetails;
